export default __webpack_public_path__ + "static/media/typography.69396914.svg";